/**
 * Estilos compartidos entre componentes del frontend.
 *
 * Mantenidos como objetos JS planos (no CSS Modules ni Tailwind) por simplicidad.
 * Cuando la app crezca consideremos migrar a una solución más robusta.
 */
export const ui = {
  card: {
    background: "#fff",
    border: "1px solid #e8e4ff",
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "20px",
    maxWidth: "780px",
    margin: "20px auto",
    fontFamily: "sans-serif",
  },
  h2: {
    fontSize: "18px",
    color: "#1a1a2e",
    marginTop: 0,
  },
  label: {
    display: "block",
    fontSize: "13px",
    color: "#555",
    marginBottom: "6px",
    fontWeight: 500,
  },
  input: {
    width: "100%",
    border: "1px solid #d8d4ff",
    borderRadius: "8px",
    padding: "10px 14px",
    fontSize: "14px",
    fontFamily: "sans-serif",
    boxSizing: "border-box",
    outline: "none",
    color: "#1a1a2e",
  },
  textarea: {
    width: "100%",
    border: "1px solid #d8d4ff",
    borderRadius: "8px",
    padding: "10px 14px",
    fontSize: "14px",
    fontFamily: "sans-serif",
    boxSizing: "border-box",
    outline: "none",
    color: "#1a1a2e",
    minHeight: "70px",
    resize: "vertical",
  },
  primaryBtn: {
    background: "#6c63ff",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "10px 22px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "sans-serif",
    fontWeight: 500,
  },
  secondaryBtn: {
    background: "transparent",
    color: "#6c63ff",
    border: "1px solid #6c63ff",
    borderRadius: "8px",
    padding: "8px 16px",
    fontSize: "13px",
    cursor: "pointer",
    fontFamily: "sans-serif",
  },
  errorBox: {
    background: "#fff0f0",
    border: "1px solid #ffcccc",
    borderRadius: "8px",
    padding: "12px 16px",
    color: "#c0392b",
    fontSize: "13px",
    marginTop: "12px",
  },
  chip: {
    padding: "6px 14px",
    borderRadius: "20px",
    border: "1px solid #d8d4ff",
    background: "#fff",
    color: "#6c63ff",
    fontSize: "12px",
    cursor: "pointer",
    fontFamily: "sans-serif",
  },
  // Card seleccionable (sugerencias, opciones)
  optionCard: (checked) => ({
    border: "1px solid " + (checked ? "#6c63ff" : "#e0dbff"),
    background: checked ? "#f3f1ff" : "#fff",
    borderRadius: "10px",
    padding: "14px 16px",
    marginBottom: "10px",
    cursor: "pointer",
    display: "flex",
    gap: "12px",
    alignItems: "flex-start",
    transition: "all 0.12s",
  }),
  checkbox: (checked) => ({
    width: "18px",
    height: "18px",
    borderRadius: "5px",
    border: "2px solid " + (checked ? "#6c63ff" : "#ccc"),
    background: checked ? "#6c63ff" : "#fff",
    flexShrink: 0,
    marginTop: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "11px",
  }),
  // Badge informativo (precio sugerido, producto elegido, etc.)
  infoBadge: {
    background: "#f0eeff",
    borderRadius: "8px",
    padding: "12px 16px",
    marginTop: "12px",
    fontSize: "13px",
    color: "#4a45a0",
  },
  successBadge: {
    background: "#f0fff4",
    borderRadius: "8px",
    padding: "10px 14px",
    marginBottom: "14px",
    fontSize: "13px",
    color: "#1a6b3a",
  },
};

// Función helper para disable visual de botones
export const disabledStyle = { opacity: 0.5, cursor: "not-allowed" };
